import React from 'react';
import { Helmet } from 'react-helmet-async';
import BasketballHero from '../components/BasketballHero';
import BasketballNameGenerator from '../components/BasketballNameGenerator';
import BasketballFeatures from '../components/BasketballFeatures';
import BasketballHowItWorks from '../components/BasketballHowItWorks';
import BasketballTestimonials from '../components/BasketballTestimonials';
import BasketballGuide from '../components/BasketballGuide';
import BasketballSEOContent from '../components/BasketballSEOContent';
import BasketballFAQ from '../components/BasketballFAQ';
import BasketballCallToAction from '../components/BasketballCallToAction';

export default function BasketballPage() {
  return (
    <>
      <Helmet>
        <title>Basketball Team Name Generator | Create Winning Team Names</title>
      </Helmet>
      <BasketballHero />
      <BasketballNameGenerator />
      <BasketballFeatures />
      <BasketballHowItWorks />
      <BasketballTestimonials />
      <BasketballGuide />
      <BasketballSEOContent />
      <BasketballFAQ />
      <BasketballCallToAction />
    </>
  );
}